/* Suitality 2.0: product tiles, instant product browser, company lookup. No dependencies. */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    var n = (cents / 100).toFixed(2);
    var withComma = n.replace('.', ',');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, n);
  };
  var euros = function (cents) { return money(cents).replace(/[,.]00(?=\D*$)/, ''); };

  /* ---------- Add to cart from a tile ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-s-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.elements['id'].value), quantity: Number(form.elements['quantity'].value) }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__bubble-num').forEach(function (n) { n.textContent = cart.item_count; });
        document.querySelectorAll('.cart-link__bubble').forEach(function (b) { b.classList.add('cart-link__bubble--visible'); });
        document.dispatchEvent(new CustomEvent('cart:build'));
        var link = document.createElement('a');
        link.href = '/cart';
        link.className = 'btn s-tile__btn s-tile__btn--done';
        link.textContent = 'Added, view cart';
        form.replaceWith(link);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        var msg = (err && (err.description || err.message)) || 'This product could not be added. Open the product to choose a quantity.';
        var p = form.parentNode.querySelector('.s-tile__err') || document.createElement('p');
        p.className = 's-tile__err';
        p.setAttribute('role', 'alert');
        p.textContent = msg;
        form.parentNode.appendChild(p);
      });
  });

  /* ---------- Instant product browser (collections, suppliers, search) ---------- */
  function Browser(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-sb-config]').textContent);
    this.grid = root.querySelector('[data-sb-grid]');
    this.tiles = Array.prototype.slice.call(this.grid.querySelectorAll('.s-tile'));
    this.tiles.forEach(function (t, i) { t.dataset.order = i; });
    this.shown = 0;
    this.step = 24;
    this.autoLimit = 96;
    this.state = this.readUrl();
    this.build();
    this.apply();
    this.loadRest();
  }

  Browser.prototype.readUrl = function () {
    var p = new URLSearchParams(location.search);
    return {
      sub: p.get('sub') || '',
      vendors: p.getAll('supplier'),
      segments: p.getAll('segment'),
      min: p.get('min') ? Number(p.get('min')) * 100 : null,
      max: p.get('max') ? Number(p.get('max')) * 100 : null,
      stock: p.get('stock') === '1',
      sort: p.get('sort') || 'featured'
    };
  };

  Browser.prototype.writeUrl = function () {
    var p = new URLSearchParams(location.search);
    ['sub', 'supplier', 'segment', 'min', 'max', 'stock', 'sort', 'page'].forEach(function (k) { p.delete(k); });
    var s = this.state;
    if (s.sub) p.set('sub', s.sub);
    s.vendors.forEach(function (v) { p.append('supplier', v); });
    s.segments.forEach(function (v) { p.append('segment', v); });
    if (s.min !== null && s.min > this.range[0]) p.set('min', Math.floor(s.min / 100));
    if (s.max !== null && s.max < this.range[1]) p.set('max', Math.ceil(s.max / 100));
    if (s.stock) p.set('stock', '1');
    if (s.sort !== 'featured') p.set('sort', s.sort);
    var q = p.toString();
    history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
  };

  Browser.prototype.build = function () {
    var self = this;
    var r = this.root;

    // Sub-category chips act as filters on the same page
    r.querySelectorAll('[data-sb-sub]').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        var h = chip.dataset.sbSub;
        self.state.sub = self.state.sub === h ? '' : h;
        self.apply(true);
      });
    });

    var allChip = r.querySelector('[data-sb-sub-all]');
    if (allChip) allChip.addEventListener('click', function () { self.state.sub = ''; self.apply(true); });

    this.vendorBox = r.querySelector('[data-sb-vendors]');
    this.vendorSearch = r.querySelector('[data-sb-vendor-search]');
    if (this.vendorSearch) {
      this.vendorSearch.addEventListener('input', function () {
        var q = self.vendorSearch.value.trim().toLowerCase();
        self.vendorBox.querySelectorAll('li').forEach(function (li) {
          li.hidden = q && li.dataset.name.indexOf(q) === -1;
        });
      });
    }

    var stock = r.querySelector('[data-sb-stock]');
    if (stock) {
      stock.checked = this.state.stock;
      stock.addEventListener('change', function () { self.state.stock = stock.checked; self.apply(true); });
    }

    var sort = r.querySelector('[data-sb-sort]');
    if (sort) {
      sort.value = this.state.sort;
      sort.addEventListener('change', function () { self.state.sort = sort.value; self.apply(true); });
    }

    r.querySelectorAll('[data-sb-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.state = { sub: '', vendors: [], segments: [], min: null, max: null, stock: false, sort: self.state.sort };
        if (stock) stock.checked = false;
        if (self.resetPrice) self.resetPrice();
        self.apply(true);
      });
    });

    this.more = r.querySelector('[data-sb-more]');
    if (this.more) this.more.addEventListener('click', function () { self.reveal(48); });

    this.sentinel = r.querySelector('[data-sb-sentinel]');
    if (this.sentinel) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; self.autoReveal(); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) self.autoReveal();
        }, { rootMargin: '600px 0px' }).observe(this.sentinel);
      }
    }

    var toggle = r.querySelector('[data-sb-toggle]');
    var panel = r.querySelector('[data-sb-panel]');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.classList.toggle('is-open', open);
      });
    }

    this.setupPrice();
  };

  Browser.prototype.setupPrice = function () {
    var self = this;
    var prices = this.tiles.map(function (t) { return Number(t.dataset.price); }).filter(function (n) { return n > 0; });
    var lo = prices.length ? Math.min.apply(null, prices) : 0;
    var hi = prices.length ? Math.max.apply(null, prices) : 0;
    lo = Math.floor(lo / 100) * 100;
    hi = Math.ceil(hi / 100) * 100;
    this.range = [lo, hi];
    var box = this.root.querySelector('[data-sb-price]');
    if (!box) return;
    if (hi <= lo) { box.hidden = true; return; }
    box.hidden = false;
    var a = box.querySelector('[data-sb-min]');
    var b = box.querySelector('[data-sb-max]');
    var na = box.querySelector('[data-sb-min-num]');
    var nb = box.querySelector('[data-sb-max-num]');
    var fill = box.querySelector('[data-sb-fill]');
    var STEPS = 1000;
    // Scale follows the catalogue: each step of the track holds about the same number of products.
    var sorted = prices.slice().sort(function (x, y) { return x - y; });
    sorted[0] = lo; sorted[sorted.length - 1] = hi;
    function toPrice(pos) {
      var f = pos / STEPS * (sorted.length - 1), i = Math.floor(f), v = sorted[i] + (sorted[Math.min(i + 1, sorted.length - 1)] - sorted[i]) * (f - i);
      var unit = v < 10000 ? 100 : v < 100000 ? 500 : 1000;
      return Math.min(hi, Math.max(lo, Math.round(v / unit) * unit));
    }
    function toPos(price) {
      if (price <= sorted[0]) return 0;
      if (price >= sorted[sorted.length - 1]) return STEPS;
      var i = 0;
      while (i < sorted.length - 1 && sorted[i + 1] < price) i++;
      var span = sorted[i + 1] - sorted[i], f = span ? (price - sorted[i]) / span : 0;
      return Math.round((i + f) / (sorted.length - 1) * STEPS);
    }
    [a, b].forEach(function (i) { i.min = 0; i.max = STEPS; i.step = 1; });
    [na, nb].forEach(function (i) { i.min = lo / 100; i.max = hi / 100; });
    a.value = this.state.min !== null ? toPos(Math.max(lo, this.state.min)) : 0;
    b.value = this.state.max !== null ? toPos(Math.min(hi, this.state.max)) : STEPS;
    this.resetPrice = function () { a.value = 0; b.value = STEPS; paint(); };

    function paint() {
      var x = Number(a.value), y = Number(b.value);
      var px = x === 0 ? self.range[0] : toPrice(x), py = y === STEPS ? self.range[1] : toPrice(y);
      na.value = Math.floor(px / 100);
      nb.value = Math.ceil(py / 100);
      fill.style.left = (x / STEPS * 100) + '%';
      fill.style.width = ((y - x) / STEPS * 100) + '%';
      a.setAttribute('aria-valuetext', euros(px));
      b.setAttribute('aria-valuetext', euros(py));
    }
    function fromSliders(which) {
      var x = Number(a.value), y = Number(b.value);
      if (x > y) { if (which === a) a.value = y; else b.value = x; x = Number(a.value); y = Number(b.value); }
      paint();
      self.state.min = x > 0 ? toPrice(x) : null;
      self.state.max = y < STEPS ? toPrice(y) : null;
      self.apply(true);
    }
    function fromNumbers(k, input) {
      var v = Math.round(Number(input.value) * 100);
      if (isNaN(v)) return;
      v = Math.min(self.range[1], Math.max(self.range[0], v));
      (k === 0 ? a : b).value = toPos(v);
      paint();
      if (k === 0) { self.state.min = v > self.range[0] ? v : null; na.value = v / 100; }
      else { self.state.max = v < self.range[1] ? v : null; nb.value = v / 100; }
      self.apply(true);
    }
    this.paintPrice = paint;
    this.fromSliders = fromSliders;
    this.fromNumbers = fromNumbers;
    paint();
    if (this.priceBound) return;
    this.priceBound = true;
    var t;
    [a, b].forEach(function (i) {
      i.addEventListener('input', function () { self.paintPrice(); clearTimeout(t); t = setTimeout(function () { self.fromSliders(i); }, 120); });
    });
    [na, nb].forEach(function (i, k) {
      i.addEventListener('change', function () { self.fromNumbers(k, i); });
    });
  };

  Browser.prototype.matches = function (t, skip) {
    var s = this.state;
    if (skip !== 'sub' && s.sub && t.dataset.collections.indexOf(' ' + s.sub + ' ') === -1) return false;
    if (skip !== 'vendor' && s.vendors.length && s.vendors.indexOf(t.dataset.vendor) === -1) return false;
    if (skip !== 'segment' && s.segments.length && s.segments.indexOf(t.dataset.segment || '') === -1) return false;
    var price = Number(t.dataset.price);
    if (skip !== 'price') {
      if (s.min !== null && price < s.min) return false;
      if (s.max !== null && price > s.max) return false;
    }
    if (skip !== 'stock' && s.stock && t.dataset.available !== '1') return false;
    return true;
  };

  Browser.prototype.renderVendors = function () {
    if (!this.vendorBox) return;
    var self = this, counts = {};
    this.tiles.forEach(function (t) {
      var v = t.dataset.vendor;
      if (!(v in counts)) counts[v] = 0;
      if (self.matches(t, 'vendor')) counts[v]++;
    });
    var names = Object.keys(counts).sort(function (x, y) { return x.localeCompare(y); });
    var wrap = this.root.querySelector('[data-sb-vendor-wrap]');
    if (wrap) wrap.hidden = names.length < 2;
    if (this.vendorSearch) this.vendorSearch.hidden = names.length <= 8;
    var q = this.vendorSearch ? this.vendorSearch.value.trim().toLowerCase() : '';
    this.vendorBox.innerHTML = '';
    names.forEach(function (n) {
      var li = document.createElement('li');
      li.dataset.name = n.toLowerCase();
      if (q && li.dataset.name.indexOf(q) === -1) li.hidden = true;
      var on = self.state.vendors.indexOf(n) !== -1;
      var id = 'sb-v-' + n.replace(/[^a-z0-9]/gi, '-');
      li.innerHTML = '<label class="s-check" for="' + id + '"><input type="checkbox" id="' + id + '"' + (on ? ' checked' : '') + (counts[n] === 0 && !on ? ' disabled' : '') + '><span class="s-check__label"></span><span class="s-check__count">' + counts[n] + '</span></label>';
      li.querySelector('.s-check__label').textContent = n;
      li.querySelector('input').addEventListener('change', function (e) {
        if (e.target.checked) self.state.vendors.push(n);
        else self.state.vendors = self.state.vendors.filter(function (x) { return x !== n; });
        self.apply(true);
      });
      self.vendorBox.appendChild(li);
    });
  };

  // Market segment (Luxury, Upscale, Midscale, Economy), set by each supplier in Webkul
  Browser.prototype.renderSegments = function () {
    var box = this.root.querySelector('[data-sb-segments]');
    if (!box) return;
    var self = this, order = ['Luxury', 'Upscale', 'Midscale', 'Economy'], counts = {};
    order.forEach(function (n) { counts[n] = 0; });
    var any = false;
    this.tiles.forEach(function (t) {
      var v = t.dataset.segment || '';
      if (!(v in counts)) return;
      any = true;
      if (self.matches(t, 'segment')) counts[v]++;
    });
    var wrap = this.root.querySelector('[data-sb-segment-wrap]');
    if (wrap) wrap.hidden = !any && !this.state.segments.length;
    box.innerHTML = '';
    order.forEach(function (n) {
      var on = self.state.segments.indexOf(n) !== -1;
      if (!counts[n] && !on) return;
      var li = document.createElement('li');
      var id = 'sb-s-' + n.toLowerCase();
      li.innerHTML = '<label class="s-check" for="' + id + '"><input type="checkbox" id="' + id + '"' + (on ? ' checked' : '') + '><span class="s-check__label"></span><span class="s-check__count">' + counts[n] + '</span></label>';
      li.querySelector('.s-check__label').textContent = n;
      li.querySelector('input').addEventListener('change', function (e) {
        if (e.target.checked) self.state.segments.push(n);
        else self.state.segments = self.state.segments.filter(function (x) { return x !== n; });
        self.apply(true);
      });
      box.appendChild(li);
    });
  };

  Browser.prototype.renderSubs = function () {
    var self = this;
    this.root.querySelectorAll('[data-sb-sub]').forEach(function (chip) {
      var h = chip.dataset.sbSub;
      var n = self.tiles.filter(function (t) { return t.dataset.collections.indexOf(' ' + h + ' ') !== -1 && self.matches(t, 'sub'); }).length;
      var on = self.state.sub === h;
      chip.classList.toggle('s-chip--active', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      var c = chip.querySelector('.s-chip__n');
      if (c) c.textContent = n;
      chip.hidden = n === 0 && !on && self.loaded;
    });
    var all = this.root.querySelector('[data-sb-sub-all]');
    if (all) { all.classList.toggle('s-chip--active', !this.state.sub); all.setAttribute('aria-pressed', this.state.sub ? 'false' : 'true'); }
  };

  Browser.prototype.renderActive = function () {
    var self = this, box = this.root.querySelector('[data-sb-active]');
    if (!box) return;
    box.innerHTML = '';
    var add = function (label, fn) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 's-chip s-chip--active';
      b.innerHTML = '<span></span><span class="s-chip__x" aria-hidden="true">×</span><span class="visually-hidden">Remove filter</span>';
      b.firstChild.textContent = label;
      b.addEventListener('click', function () { fn(); self.apply(true); });
      box.appendChild(b);
    };
    var s = this.state;
    if (s.sub) {
      var chip = this.root.querySelector('[data-sb-sub="' + s.sub + '"]');
      add(chip ? chip.dataset.label : s.sub, function () { s.sub = ''; });
    }
    s.vendors.forEach(function (v) { add(v, function () { s.vendors = s.vendors.filter(function (x) { return x !== v; }); }); });
    s.segments.forEach(function (v) { add(v, function () { s.segments = s.segments.filter(function (x) { return x !== v; }); }); });
    if (s.min !== null || s.max !== null) {
      add(euros(s.min !== null ? s.min : this.range[0]) + ' to ' + euros(s.max !== null ? s.max : this.range[1]), function () {
        s.min = null; s.max = null;
        var box2 = self.root.querySelector('[data-sb-price]');
        if (self.resetPrice) self.resetPrice();
      });
    }
    if (s.stock) add('In stock', function () { s.stock = false; var st = self.root.querySelector('[data-sb-stock]'); if (st) st.checked = false; });
    var n = box.children.length;
    this.root.querySelectorAll('[data-sb-clear]').forEach(function (b) { b.hidden = n === 0; });
    var badge = this.root.querySelector('[data-sb-count-filters]');
    if (badge) badge.textContent = n ? ' (' + n + ')' : '';
  };

  Browser.prototype.apply = function (user) {
    var self = this, s = this.state;
    var list = this.tiles.filter(function (t) { return self.matches(t); });
    var cmp = {
      featured: function (x, y) { return x.dataset.order - y.dataset.order; },
      'price-asc': function (x, y) { return x.dataset.price - y.dataset.price; },
      'price-desc': function (x, y) { return y.dataset.price - x.dataset.price; },
      'title-asc': function (x, y) { return x.dataset.title.localeCompare(y.dataset.title); },
      newest: function (x, y) { return y.dataset.created - x.dataset.created; }
    }[s.sort] || function (x, y) { return x.dataset.order - y.dataset.order; };
    list.sort(cmp);
    this.list = list;
    var frag = document.createDocumentFragment();
    list.forEach(function (t) { frag.appendChild(t); });
    this.tiles.forEach(function (t) { if (list.indexOf(t) === -1) { t.hidden = true; frag.appendChild(t); } });
    this.grid.appendChild(frag);
    this.shown = 0;
    this.list.forEach(function (t) { t.hidden = true; });
    this.reveal(this.step);

    var total = list.length;
    var countEl = this.root.querySelector('[data-sb-count]');
    if (countEl) countEl.textContent = total + (total === 1 ? ' product' : ' products') + (this.loaded ? '' : '+');
    var empty = this.root.querySelector('[data-sb-empty]');
    if (empty) empty.hidden = total !== 0 || !this.loaded;

    this.renderVendors();
    this.renderSegments();
    this.renderSubs();
    this.renderActive();
    if (user) {
      this.writeUrl();
      var top = this.root.querySelector('[data-sb-top]');
      if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Infinite scroll: reveal the next batch while the end of the grid is near the viewport, up to autoLimit.
  Browser.prototype.autoReveal = function () {
    if (!this.sentinel || !this.list || this.shown >= this.autoLimit || this.shown >= this.list.length) return;
    if (this.sentinel.getBoundingClientRect().top < window.innerHeight + 600) this.reveal(this.step);
  };

  Browser.prototype.reveal = function (n) {
    var end = Math.min(this.list.length, this.shown + n);
    for (var i = this.shown; i < end; i++) this.list[i].hidden = false;
    this.shown = end;
    var left = this.list.length - this.shown;
    if (this.more) {
      this.more.hidden = !(left > 0 && this.shown >= this.autoLimit);
      this.more.textContent = 'Show more products (' + left + ' more)';
    }
    var status = this.root.querySelector('[data-sb-status]');
    if (status) status.textContent = left > 0 ? 'Showing ' + this.shown + ' of ' + this.list.length : '';
  };

  Browser.prototype.loadRest = function () {
    var self = this, cfg = this.cfg;
    if (!cfg.pages || cfg.pages <= 1) { this.loaded = true; this.apply(false); return; }
    var page = 2;
    var next = function () {
      if (page > cfg.pages || page > 12) { self.loaded = true; self.apply(false); return; }
      var u = new URL(cfg.url, location.origin);
      u.searchParams.set('page', page);
      u.searchParams.set('section_id', cfg.section);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-sb-grid] .s-tile').forEach(function (t) {
          var node = document.importNode(t, true);
          node.dataset.order = self.tiles.length;
          node.hidden = true;
          self.grid.appendChild(node);
          self.tiles.push(node);
        });
        page++;
        self.setupPrice();
        self.apply(false);
        next();
      }).catch(function () { self.loaded = true; self.apply(false); });
    };
    next();
  };

  document.querySelectorAll('[data-sb]').forEach(function (root) {
    try { new Browser(root); } catch (err) { root.classList.add('sb-nojs'); }
  });

  /* Company, VAT and address helpers live in suitality-forms.js */
})();
